module.exports = __webpack_public_path__ + "media/images/icons/store_categories/icon-store-category-1-e32f9759debdef2bf589d281d87584db.svg";